import {Injectable} from '@angular/core';
import {GuardService} from '../services/guard.service';
import {StoreService} from '../services/store.service';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {PermissionService} from '../services/permission.service';
import {RedirectService} from '../services/redirect.service';

@Injectable()
export class AuthUsersGuard {

  constructor(private _router: Router,
              private _guardService: GuardService,
              private _storeService: StoreService,
              private _redirectService: RedirectService,
              private _permissionService: PermissionService) {
  }


  async canActivate(route: ActivatedRouteSnapshot) {

    await this._guardService.isAuth();

    if (this._guardService.auth)
      return await this.callBackReq(route);
    else {
      return this._router.createUrlTree(['login']);
    }
  }


  async callBackReq(route: any) {
    const permission = route.data.permission;

    if (!permission) return true;

    const loop = this._redirectService.control();
    if (loop)
      return this._router.createUrlTree(loop);

    if (this._permissionService.get(permission))
      return true;

    alert('Forbidden, sorry');
    return this._router.createUrlTree(['dashboard']);
  }
}
